import Vue from "vue";
import Router from "vue-router";
import { getTokenCodeApi, getUserInfoApi, getWeixinTokenCodeApi, getWeixinUserInfoApi, getHydApi, getHydWechatApi } from "@/api/login";
import { getPetUserApi } from "@/api/user";
import { formatOwnerNum } from "@/utils/index";
import { getLocation, getLocationWeixin } from "@/utils/location";
import { getEnvironment } from "@/utils/distinguishEnvironment";

import store from "@/store";
Vue.use(Router);

import { Toast } from "vant";

const routes = [
  // {
  //   path: "/",
  //   name: "home",
  //   component: () => import("@/views/home/index"),
  //   meta: {
  //     title: "人宠共患病防控一件事",
  //   },
  // },
  {
    path: "/",
    name: "home",
    component: () => import("@/views/homeNew/index"),
    redirect: "/homeNew/homePage",
    meta: {
      title: "人宠共患病防控一件事",
    },
    children: [
      {
        path: "/homeNew/homePage",
        name: "homePage",
        component: () => import("@/views/homeNew/homePage.vue"),
        meta: {
          title: "人宠共患病防控一件事",
        },
      },
      {
        path: "/homeNew/messagePage",
        name: "messagePage",
        component: () => import("@/views/homeNew/messagePage.vue"),
        meta: {
          title: "人宠共患病防控一件事",
        },
      },
      {
        path: "/homeNew/minePage",
        name: "minePage",
        component: () => import("@/views/homeNew/minePage.vue"),
        meta: {
          title: "人宠共患病防控一件事",
        },
      },
    ]
  },
  {
    path: "/Evangelism",
    name: "Evangelism",
    component: () => import("@/views/Evangelism/index"),
    meta: {
      title: "宣教",
    },
  },
  {
    path: "/EvangelismDetail",
    name: "EvangelismDetail",
    component: () => import("@/views/Evangelism/detail"),
    meta: {
      title: "详情",
    },
  },
  {
    path: "/scientificGuidance",
    name: "scientificGuidance",
    component: () => import("@/views/scientificGuidance/index"),
    meta: {
      title: "科学养宠指导",
    },
  },
  {
    path: "/message",
    name: "message",
    component: () => import("@/views/message/index"),
    meta: {
      title: "消息列表",
    },
  },
  {
    path: "/reservationImmunity",
    name: "reservationImmunity",
    component: () => import("@/views/reservationImmunity/index"),
    meta: {
      title: "选择免疫项目",
    },
  },
  {
    path: "/reservationImmunity/entrance",
    name: "reservationImmunityEntrance",
    component: () => import("@/views/reservationImmunity/entrance"),
    meta: {
      title: "免疫预约",
    },
  },
  {
    path: "/reservationImmunity/reserveInfo",
    name: "reserveInfo",
    component: () => import("@/views/reservationImmunity/reserveInfo"),
    meta: {
      title: "预约信息",
    },
  },

  {
    path: "/reservationImmunity/addReserveInfo",
    name: "addReserveInfo",
    component: () => import("@/views/reservationImmunity/addReserveInfo"),
    meta: {
      title: "填写预约信息",
    },
  },
  {
    path: "/reservationImmunity/petHospital",
    name: "petHospital",
    component: () => import("@/views/reservationImmunity/petHospital"),
    meta: {
      title: "选择检测点",
    },
  },
  {
    path: "/reservationImmunity/reserveHistory",
    name: "reserveHistory",
    component: () => import("@/views/reservationImmunity/reserveHistory"),
    meta: {
      title: "预约记录",
    },
  },
  {
    path: "/reservationImmunity/immunityHistory",
    name: "immunityHistory",
    component: () => import("@/views/reservationImmunity/immunityHistory"),
    meta: {
      title: "免疫记录",
    },
  },
  {
    path: "/reservationImmunity/area",
    name: "area",
    component: () => import("@/views/reservationImmunity/area"),
    meta: {
      title: "选择地区",
    },
  },
  {
    path: "/reservationImmunity/nameAuthN",
    name: "nameAuthN",
    component: () => import("@/views/reservationImmunity/nameAuthN"),
    meta: {
      title: "实名认证",
    },
  },
  {
    path: "/myPet",
    name: "myPet",
    component: () => import("@/views/myPet/index"),
    meta: {
      title: "宠物列表",
    },
  },
  {
    path: "/mypet/addPet",
    name: "addPet",
    component: () => import("@/views/myPet/addPet"),
    meta: {
      title: "宠物档案",
    },
  },
  {
    path: "/mypet/createSuccess",
    name: "createSuccess",
    component: () => import("@/views/myPet/createSuccess.vue"),
    meta: {
      title: "创建成功",
    },
  },
  {
    path: "/mypet/addCase",
    name: "addCase",
    component: () => import("@/views/myPet/addCase"),
    meta: {
      title: "新建病例",
    },
  },
  {
    path: "/mypet/petInfo",
    name: "petInfo",
    component: () => import("@/views/myPet/petInfo"),
    meta: {
      title: "宠物档案",
    },
  },
  {
    path: "/myPet/selectBreed",
    name: "selectBreed",
    component: () => import("@/views/myPet/selectBreed"),
    meta: {
      title: "宠物品种选择",
    },
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/search/index"),
    meta: {
      title: "搜索",
    },
  },
  {
    path: "/uploadPaperCertificate",
    name: "uploadPaperCertificate",
    component: () => import("@/views/uploadPaperCertificate/index"),
    meta: {
      title: "上传纸质证明",
    },
  },
  {
    path: "/uploadPaperCertificate/uploadDog",
    name: "uploadDog",
    component: () => import("@/views/uploadPaperCertificate/uploadDog"),
    meta: {
      title: "上传纸质犬证",
    },
  },
  {
    path: "/uploadPaperCertificate/uploadImmunity",
    name: "uploadImmunity",
    component: () => import("@/views/uploadPaperCertificate/uploadImmunity"),
    meta: {
      title: "上传纸质免疫证明",
    },
  },
  {
    path: "/uploadPaperDog",
    name: "uploadPaperDog",
    component: () => import("@/views/uploadPaperDog/index"),
    meta: {
      title: "上传纸质犬证",
    },
  },
  {
    path: "/uploadPaperDog/uploadDog",
    name: "uploadDogZheng",
    component: () => import("@/views/uploadPaperDog/uploadDog"),
    meta: {
      title: "上传纸质犬证",
    },
  },
  {
    path: "/petCode",
    name: "petCode",
    component: () => import("@/views/petCode/index"),
    meta: {
      title: "宠康码",
    },
  },
  {
    path: "/ScanCodeLogin",
    name: "ScanCodeLogin",
    component: () => import("@/views/ScanCodeLogin/index"),
    meta: {
      title: "扫码签到",
    },
  },
  {
    path: "/immuneComment",
    name: "immuneComment",
    component: () => import("@/views/ScanCodeLogin/comment"),
    meta: {
      title: "评论",
    },
  },
  {
    path: "/EleImmuneCard",
    name: "EleImmuneCard",
    component: () => import("@/views/EleImmuneCard/index"),
    meta: {
      title: "电子免疫证明",
    },
  },
  {
    path: "/petDeathReport",
    name: "petDeathReport",
    component: () => import("@/views/petDeathReport/index"),
    meta: {
      title: "宠物死亡填报",
    },
  },
  {
    path: "/petTransfer",
    name: "petTransfer",
    component: () => import("@/views/petTransfer/index"),
    meta: {
      title: "宠主绑定信息变更",
    },
  },
  {
    path: "/addTransfer",
    name: "addTransfer",
    component: () => import("@/views/petTransfer/addTransfer"),
    meta: {
      title: "填写过户信息",
    },
  },
  {
    path: "/antibodyTestingAppointment/entrance",
    name: "antibodyTestingAppointmentEntrance",
    component: () => import("@/views/antibodyTestingAppointment/entrance"),
    meta: {
      title: "抗体检测",
    },
  },
  {
    path: "/antibodyTestingAppointment",
    name: "antibodyTestingAppointment",
    component: () => import("@/views/antibodyTestingAppointment/index"),
    meta: {
      title: "抗体检测预约",
    },
  },
  {
    path: "/geneDetection",
    name: "geneDetection",
    component: () => import("@/views/geneDetection/index"),
    meta: {
      title: "宠物基因检测",
    },
  },
  {
    path: "/geneDetection/entrance",
    name: "geneDetectionEntrance",
    component: () => import("@/views/geneDetection/entrance"),
    meta: {
      title: "宠物基因检测",
    },
  },
  {
    path: "/geneDetection/report",
    name: "report",
    component: () => import("@/views/geneDetection/report"),
    meta: {
      title: "基因检测报告",
    },
  },
  {
    path: "/placeCodeEntrance",
    name: "placeCodeEntrance",
    component: () => import("@/views/placeCode/entrance"),
    meta: {
      title: "申请场所码",
    },
  },
  {
    path: "/minePlaceCode",
    name: "minePlaceCode",
    component: () => import("@/views/placeCode/minePlaceCode"),
    meta: {
      title: "我的场所码",
    },
  },
  {
    path: "/placeCode",
    name: "placeCode",
    component: () => import("@/views/placeCode/index"),
    meta: {
      title: "场所码",
    },
  },
  {
    path: "/scanRecord",
    name: "scanRecord",
    component: () => import("@/views/placeCode/scanRecord"),
    meta: {
      title: "扫码记录",
    },
  },
  {
    path: "/applyRecord",
    name: "applyRecord",
    component: () => import("@/views/placeCode/applyRecord"),
    meta: {
      title: "申请记录",
    },
  },
  {
    path: "/addPlaceCode",
    name: "addPlaceCode",
    component: () => import("@/views/placeCode/addPlaceCode"),
    meta: {
      title: "申请长期场所码",
    },
  },
  {
    path: "/downgrade",
    name: "downgrade",
    component: () => import("@/views/downgrade-page/index"),
    meta: {
      title: "加载失败",
    },
  },
  {
    path: "/comprehensiveQuery",
    name: "comprehensiveQuery",
    component: () => import("@/views/comprehensiveQuery/index"),
    meta: {
      title: "综合查询",
    },
  },
  {
    path: "/notYetDeveloped",
    name: "notYetDeveloped",
    component: () => import("@/views/notYetDeveloped/index"),
    meta: {
      title: "暂未开放",
    },
  },
  {
    path: "/suspectedCaseReport",
    name: "suspectedCaseReport",
    component: () => import("@/views/suspectedCaseReport/index"),
    meta: {
      title: "疑似病例上报",
    },
  },
  {
    path: "/addSuspectedCaseReport",
    name: "addSuspectedCaseReport",
    component: () => import("@/views/suspectedCaseReport/addInfo"),
    meta: {
      title: "疑似病例上报",
    },
  },
  {
    path: "/breedingInstitutions",
    name: "breedingInstitutions",
    component: () => import("@/views/breedingInstitutions/index"),
    meta: {
      title: "繁育机构登记",
    },
  },
  {
    path: "/registrationMedicalInstitutions",
    name: "registrationMedicalInstitutions",
    component: () => import("@/views/registrationMedicalInstitutions/index"),
    meta: {
      title: "诊疗机构登记",
    },
  },
  {
    path: "/pdf",
    name: "pdf",
    component: () => import("@/views/geneDetection/pdf"),
    meta: {
      title: "预览",
    },
  },
  {
    path: "/questionnaire",
    name: "questionnaire",
    component: () => import("@/views/questionnaire/index"),
    meta: {
      title: "调查问卷",
    },
  },
  {
    path: "/questionDetail",
    name: "questionDetail",
    component: () => import("@/views/questionnaire/questionDetail"),
    meta: {
      title: "问卷详情",
    },
  },
  {
    path: "/complaintsAndSuggestions",
    name: "complaintsAndSuggestions",
    component: () => import("@/views/complaintsAndSuggestions/index"),
    meta: {
      title: "功能体验反馈",
    },
  },
  {
    path: "/petHealthConsultation",
    name: "petHealthConsultation",
    // component: () => import("@/views/petHealthConsultation/index"),
    component: () => import("@/views/petHealthConsultation/newIndex"),
    meta: {
      title: "宠物健康咨询",
      keepAlive: true,
    },
  },
  {
    path: "/petHealthConsultationRecord",
    name: "petHealthConsultationRecord",
    component: () => import("@/views/petHealthConsultation/record"),
    meta: {
      title: "宠物健康咨询记录",
    },
  },
  {
    path: "/petHealthConsultationNewRecord",
    name: "petHealthConsultationNewRecord",
    component: () => import("@/views/petHealthConsultation/newRecord"),
    meta: {
      title: "宠物健康咨询记录",
    },
  },
  {
    path: "/quarantineApply",
    name: "quarantineApply",
    component: () => import("@/views/quarantineApply/index"),
    meta: {
      title: "宠物检疫申报预约",
    },
  },
  {
    path: "/quarantineApplyProgress",
    name: "quarantineApplyProgress",
    component: () => import("@/views/quarantineApply/applyProgress"),
    meta: {
      title: "查看申报进度",
    },
  },
  {
    path: "/quarantineApplyAdd",
    name: "quarantineApplyAdd",
    component: () => import("@/views/quarantineApply/addApply"),
    meta: {
      title: "填写预约信息",
    },
  },
  {
    path: "/dogAndCatAdoption",
    name: "dogAndCatAdoption",
    component: () => import("@/views/dogAndCatAdoption/index"),
    meta: {
      title: "犬猫领养",
    },
  },
  {
    path: "/dogAndCatAdoptionDetail",
    name: "dogAndCatAdoptionDetail",
    component: () => import("@/views/dogAndCatAdoption/detail"),
    meta: {
      title: "犬猫领养详情",
    },
  },
  {
    path: "/dogAndCatAdoptionAddInfo",
    name: "dogAndCatAdoptionAddInfo",
    component: () => import("@/views/dogAndCatAdoption/addInfo"),
    meta: {
      title: "发布送养信息",
    },
  },
  {
    path: "/dogAndCatAdoptionApplyInfo",
    name: "dogAndCatAdoptionApplyInfo",
    component: () => import("@/views/dogAndCatAdoption/applyInfo"),
    meta: {
      title: "申请领养资格",
    },
  },
  {
    path: "/vaccineScanningWarehousing",
    name: "vaccineScanningWarehousing",
    component: () => import("@/views/vaccineScanningWarehousing/index"),
    meta: {
      title: "免疫接种",
    },
  },
  {
    path: "/deimmunization",
    name: "deimmunization",
    component: () => import("@/views/vaccineScanningWarehousing/deimmunization"),
    meta: {
      title: "免疫接种",
    },
  },
  {
    path: "/deiSuccess",
    name: "deiSuccess",
    component: () => import("@/views/vaccineScanningWarehousing/success"),
    meta: {
      title: "免疫接种",
    },
  },
  {
    path: "/scanResult",
    name: "scanResult",
    component: () => import("@/views/vaccineScanningWarehousing/scanResult"),
    meta: {
      title: "免疫接种",
    },
  },
  {
    path: "/vaccineInventory",
    name: "vaccineInventory",
    component: () => import("@/views/vaccineScanningWarehousing/inventory"),
    meta: {
      title: "疫苗库存",
    },
  },
  {
    path: "/toxoplasmaGondiiTest",
    name: "toxoplasmaGondiiTest",
    component: () => import("@/views/toxoplasmaGondiiTest/index"),
    meta: {
      title: "填写预约信息",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "404",
    component: () => import("@/views/404/index"),
    meta: {
      title: "加载失败",
    },
  },
];

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior: () => ({ y: 0 }),
});
let hasOnceShow = false;
const envir = getEnvironment();
// const delay = envir=== "AppProd" || envir === "AppPre" ? 500 : 1500;
//设置路由守卫
router.beforeEach((to, from, next) => {
  // 设置title
  setTitle(to);
  // APP登录
  if (!hasOnceShow && (envir === "AppProd" || envir === "AppPre")) {
    function ready(callback) {
      // const jsapiToken = sessionStorage.getItem("jsapiToken");
      const isToken = sessionStorage.getItem("token");
      const isUserInfo = sessionStorage.getItem('userInfo')
      // 如果有令牌就不再获取了
      if (isToken && isUserInfo) {
        next();
        return;
      }
      if (window.AlipayJSBridge) {
        callback && callback();
      } else {
        document.addEventListener("AlipayJSBridgeReady", callback, false);
      }
    }
    ready(async function () {
      try {
        const tokenRes = await getTokenCodeApi();
        const jsapiToken = tokenRes.data;
        sessionStorage.setItem("jsapiToken", jsapiToken);

        AlipayJSBridge.call(
          "getYkbAuthCode",
          {
            // appId: "4caf01f7-ac03-4432-aa5f-0d3a12efe32c",
            // appId: "36575343-9952-46d4-82c6-3fe79a23b7b1",
            appId: process.env.VUE_APP_ID,
            forceScopes: ["ykb_user_info"],
            jsapiToken,
          },
          async (result) => {
            if (result.code !== 0) {
              console.warn("授权失败1:", result.message);
              Toast.fail("授权失败1");
              setTimeout(() => {
                next("/downgrade");
              }, 1000);
              return;
            }

            sessionStorage.setItem("apiAuthCode", result.data.authCode);
            const token = sessionStorage.getItem("token");
            if (token) {
              next()
              return;
            }

            try {
              const userInfoRes = await getUserInfoApi(result.data.authCode);
              if (userInfoRes.code !== 0) {
                Toast.fail("获取信息失败");
                setTimeout(() => {
                  next("/downgrade");
                }, 1000);
                return;
                // return next("/404");
              }

              const { token: userToken, userId, tid } = userInfoRes.data;
              store.commit("user/SET_TOKEN", userToken);

              if (!userToken) return;

              const petUserRes = await getPetUserApi(userId);
              if (petUserRes.code !== 0) {
                Toast.fail("获取用户信息失败");
                setTimeout(() => {
                  next("/downgrade");
                }, 1000);
                return;
                // return next("/404");
              }

              const info = {
                userId: petUserRes.data.id || "",
                userRealName: petUserRes.data.userRealName || "",
                userPhone: petUserRes.data.userPhone || "",
                userIdCard: formatOwnerNum(petUserRes.data.userIdCard),
                userHeadImg: petUserRes.data.userHeadImg,
                tid: tid,
              };

              store.commit("user/SET_USERINFO", info);
              getHydApi();
            } catch (err) {
              console.error("获取用户信息失败:", err);
              next("/404");
            }
          },
        );
        getLocation();
      } catch (err) {
        console.error("获取 jsapiToken 失败:", err);
        Toast.fail("系统异常，请稍后重试");
      }
    });
  }
  // 微信登录
  if (!hasOnceShow && (envir === "weixinProd" || envir === "weixinPre")) {
    function readyWeixin(callback) {
      const isToken = sessionStorage.getItem("token");
      const isUserInfo = sessionStorage.getItem('userInfo')
      // 如果有令牌就不再获取了
      if (isToken && isUserInfo) {
        next()
        return;
      }
      callback && callback();
    }
    readyWeixin(async function () {
      try {
        const tokenRes = await getWeixinTokenCodeApi();
        const jsapiToken = tokenRes.data;
        sessionStorage.setItem("jsapiToken", jsapiToken);
        let params = {
          // 测试
          // appId: process.env.VUE_WEIXIN_ID,
          // appId: 'ce7c8408-c982-4797-8b12-7e421b93020f',
          // 正式
          appId: 'dff7015a-ef4c-4c59-882b-dec5e5a0e4ae',
          forceScopes: ["ykb_user_info"],
          jsapiToken,
        }
        MyYkb.call(
          "getAuthorization",
          params,
          async function (data) {

            sessionStorage.setItem("wx_auth", JSON.stringify(data));
            // if (result === undefined) {
            //   console.warn("微信授权失败1:", result);
            //   Toast.fail("微信授权失败1");
            //   setTimeout(() => {
            //     next("/downgrade");
            //   }, 1000);
            //   return;
            // }
            if (data !== undefined) {
              sessionStorage.setItem("apiAuthCode", data.authCode);
              // const token = sessionStorage.getItem("token");
              // if (token) {
              //   next()
              //   return;
              // }

              try {
                //第二次进入三方页面，无论用户是否授权，都有数据返回
                // if (result.accredit && result.accredit == 0) {
                  const userInfoRes = await getWeixinUserInfoApi(data.authCode);
                  if (userInfoRes.code !== 0) {
                    Toast.fail("微信获取信息失败");
                    setTimeout(() => {
                      next("/downgrade");
                    }, 1000);
                    return;
                    // return next("/404");
                  }

                  const { token: userToken, userId, tid } = userInfoRes.data;
                  store.commit("user/SET_TOKEN", userToken);

                  if (!userToken) return;

                  const petUserRes = await getPetUserApi(userId);
                  if (petUserRes.code !== 0) {
                    Toast.fail("微信获取用户信息失败");
                    setTimeout(() => {
                      next("/downgrade");
                    }, 1000);
                    return;
                    // return next("/404");
                  }

                  const info = {
                    userId: petUserRes.data.id || "",
                    userRealName: petUserRes.data.userRealName || "",
                    userPhone: petUserRes.data.userPhone || "",
                    userIdCard: formatOwnerNum(petUserRes.data.userIdCard),
                    userHeadImg: petUserRes.data.userHeadImg,
                    tid: tid,
                  };

                  store.commit("user/SET_USERINFO", info);
                  getHydWechatApi();
                // } else {
                //   //首次进入三方页面，只拉起小程序中转页，无数据返回
                //   console.log( '微信数据未返回成功')
                // }
                getLocationWeixin();
              } catch (err) {
                console.error("微信获取用户信息失败:", err);
                next("/404");
              }
            } else {
              console.warn("微信授权失败1:", data);
              // Toast.fail("微信授权失败1");
              // setTimeout(() => {
              //   next("/downgrade");
              // }, 1000);
              // next();
              return;
            }
          },
        );
        // getLocationWeixin();
      } catch (err) {
        console.error("获取 jsapiToken 失败:", err);
        Toast.fail("系统异常，请稍后重试");
      }
    })
  }
  // if (to.name === "home" && !from.name) {
  //   setTimeout(() => {
  //     next();
  //   }, delay);
  // if (to.name === "home" && !from.name) {
  //   setTimeout(() => {
  //     next();
  //   }, 500);
  // } else {
  //   next();
  // }
  if (to.name === "home" || to.name === "homePage") {
    const isToken = sessionStorage.getItem("token");
    // 如果调用api能力失效fect，则重新获取用户信息
    if (!isToken) {
      const apiAuthCode = sessionStorage.getItem("apiAuthCode");
      if (apiAuthCode) {
        getUserInfoApi(apiAuthCode).then((res) => {
          if (res.code === 0) {
            const { token: userToken, userId, tid } = res.data;
            store.commit("user/SET_TOKEN", userToken);
            getPetUserApi(userId).then(resp => {
              if (resp.code === 0) {
                const info = {
                  userId: resp.data.id || "",
                  userRealName: resp.data.userRealName || "",
                  userPhone: resp.data.userPhone || "",
                  userIdCard: formatOwnerNum(resp.data.userIdCard),
                  userHeadImg: resp.data.userHeadImg,
                  tid: tid,
                };
                store.commit("user/SET_USERINFO", info);
                next();
              } else {
                Toast.fail("首页获取用户信息失败");
                setTimeout(() => {
                  next("/downgrade");
                }, 1000);
              }
            })
          } else {
            Toast.fail("首页获取信息失败");
            setTimeout(() => {
              next("/downgrade");
            }, 1000);
          }
        });
      } else {
        next();
      }
    } else {
      next();
    }
  } else {
    next();
  }
});

const setTitle = (to) => {
  // console.log(to, 'ooooo');
  if (to.name === "reservationImmunity") {
    const { routeName } = to.query;
    if (routeName && routeName === "geneDetection") {
      document.title = "选择基因检测项目";
    } else {
      document.title = "选择免疫项目";
    }
  } else if (to.name === "addCase") {
    const { type } = to.query;
    if (type && type === "edit") {
      document.title = "编辑病例";
    } else {
      document.title = "新建病例";
    }
  } else if (to.name === "petInfo") {
    const { routeName } = to.query;
    if (routeName && routeName === "petTransfer") {
      document.title = "宠物过户";
    } else {
      document.title = "宠物档案";
    }
  } else if (to.name === "complaintsAndSuggestions") {
    const { type } = to.query;
    if (type && type == 2) {
      document.title = "功能体验反馈";
    } else if (type && type == 3) {
      document.title = "反馈";
    } else {
      document.title = "功能体验反馈";
    }
  } else if (to.name === "addPlaceCode") {
    const { businessModel } = to.query;
    document.title =
      businessModel === "long_time" ? "申请长期场所码" : "申请临时场所码";
  } else if (to.name === "petHospital") {
    const { routeName } = to.query;
    document.title =
      routeName === "reservationImmunity" ? "选择免疫点" : routeName === "addToxoplasma" ? '选择检查点' : "选择检测点";
  }else {
    document.title = to.meta.title;
  }
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};
export default router;
